// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__ringside_condensed_460364', '__ringside_condensed_Fallback_460364'"},"className":"__className_460364","variable":"__variable_460364"};